export default "__VITE_ASSET__c7d43d08__"